// extracted by mini-css-extract-plugin
module.exports = {"Record_Detail_Title":"RecordDetailTitle_Record_Detail_Title__3bsio","Title_Container":"RecordDetailTitle_Title_Container__rNJar"};